import type { NotificationStatusValue, PushTokenStatus } from '../../services/firestore/firestoreTypes'

export type LegacyNotificationStatus = {
  status: NotificationStatusValue
  has_fcm_token: boolean
  fcm_token_status: PushTokenStatus
}

export function shouldWriteLegacyNotificationStatus(role: string): boolean {
  return role === 'parent' || role === 'employee'
}

export function legacyNotificationStatusForDevice(input: {
  status: PushTokenStatus
  onboardingStatus: NotificationStatusValue
  token: string
}): LegacyNotificationStatus {
  return {
    status: input.onboardingStatus,
    has_fcm_token: input.status === 'active' && Boolean(input.token),
    fcm_token_status: input.status,
  }
}
